import React, { useEffect, useState } from "react";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import axios from "api/baseurl";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

import {
   Typography,
    FormControlLabel,
  Box,
   Switch,
  Card,
  CardContent,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Paper,
  Pagination,
  CircularProgress,
  Chip,
  Tabs,
  Tab,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

import MDTypography from "components/MDTypography";

import { toast } from "react-toastify";

import MedicalAbstractBackground from "./MedicalAbstractBackground ";

import WarningIcon from "@mui/icons-material/Warning";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import PeopleIcon from "@mui/icons-material/People";

function RenderingDoctorDashboard() {
  const loginData = JSON.parse(localStorage.getItem("loginData"));

  const userid = loginData?.userid;
 const token = loginData?.token;
  const [loading, setLoading] = useState(true);

  const [selectedTab, setSelectedTab] = useState(0);

  // =========================================================
  // REFERRED PATIENTS
  // =========================================================

  const [referredPatients, setReferredPatients] = useState([]);
  const [referredPage, setReferredPage] = useState(1);
  const [referredTotalPages, setReferredTotalPages] = useState(1);
 const [alertCounts, setAlertCounts] = useState({
  sosCount: 0,
  warningCount: 0,
  criticalCount: 0,
});
  // =========================================================
  // ESCALATIONS
  // =========================================================

  const [pendingEscalations, setPendingEscalations] = useState([]);
  const [escalationPage, setEscalationPage] = useState(1);
  const [escalationTotalPages, setEscalationTotalPages] = useState(1);
 const [patients, setPatients] = useState([]);

  const [availability, setAvailability] = useState(false);
  const [shiftStart, setShiftStart] = useState(null);
  const [timer, setTimer] = useState("00:00:00");
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [pendingToggle, setPendingToggle] = useState(null);
  // =========================================================
  // FOLLOWUPS
  // =========================================================

  const [followups, setFollowups] = useState([]);
  const [followupPage, setFollowupPage] = useState(1);
  const [followupTotalPages, setFollowupTotalPages] = useState(1);

  // =========================================================
  // HIGH RISK
  // =========================================================

  const [highRiskPatients, setHighRiskPatients] = useState([]);
  const [highRiskPage, setHighRiskPage] = useState(1);
  const [highRiskTotalPages, setHighRiskTotalPages] = useState(1);

  // =========================================================
  // FETCH REFERRED PATIENTS
  // =========================================================
  const fetchAlerts = async () => {
    try {
      const res = await axios.get(`/api/doctorregistration/alerts/counts/${userid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
          setAlertCounts(res.data || {});

    } catch {
      toast.error("Failed to fetch alerts");
    }
  };

   // ------------------ PATIENTS ------------------ //
  const fetchPatients = async () => {
    try {
      const res = await axios.get(`/api/doctorregistration/alerts/details/${userid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPatients(res.data || []);
    } catch {
      toast.error("Failed to fetch patients");
    }
  };
const fetchAvailability = async () => {
  try {
    const res = await axios.get(
      `/api/doctorregistration/doctor/availability/${userid}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = res.data;

    setAvailability(data.availability);

    if (data.availability && data.shiftOnTime) {
      setShiftStart(data.shiftOnTime);
    } else {
      setShiftStart(null);
      setTimer("00:00:00");
    }
  } catch (err) {
    console.log(err);
  }
};
  // ------------------ TOGGLE CLICK (OPEN POPUP) ------------------ //
  const handleToggleClick = (event) => {
    setPendingToggle(event.target.checked);
    setConfirmOpen(true);
  };

  // ------------------ CONFIRM ACTION ------------------ //
  const handleConfirm = async () => {
  setConfirmOpen(false);

  try {
    await axios.post(
      "/api/doctorregistration/doctor/toggleAvailability",
      {
        userid: userid,
        availability: pendingToggle,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // Reload latest status from DB
    await fetchAvailability();

    toast.success(
      pendingToggle
        ? "You are now on duty. Your shift has started."
        : "You are now offline. Your shift has ended."
    );
  } catch (err) {
    toast.error("Failed to update availability");
  }
};
  // ------------------ TIMER ------------------ //
  useEffect(() => {
    let interval;

    if (availability && shiftStart) {
      interval = setInterval(() => {
        const start = new Date(shiftStart);
        const now = new Date();
        const diff = Math.floor((now - start) / 1000);

        const hrs = String(Math.floor(diff / 3600)).padStart(2, "0");
        const mins = String(Math.floor((diff % 3600) / 60)).padStart(2, "0");
        const secs = String(diff % 60).padStart(2, "0");

        setTimer(`${hrs}:${mins}:${secs}`);
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [availability, shiftStart]);

  // ------------------ RESTORE ------------------ //
useEffect(() => {
  fetchAvailability();
}, []);

  // ------------------ INIT ------------------ //
  useEffect(() => {
    const init = async () => {
      setLoading(true);
      await Promise.all([fetchAlerts(), fetchPatients()]);
      setLoading(false);
    };
    init();
  }, []);
  const fetchReferredPatients = async (pageNumber = 1) => {
    try {
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;

      const response = await axios.get(
        `/api/renderingdoctor/my-referred-patients/${userid}`,
        {
          params: {
            page: Math.max(0, pageNumber - 1),
          },

          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        const data = response.data;

        setReferredPatients(data.content || data || []);

        setReferredPage(data.number + 1 || pageNumber);

        setReferredTotalPages(data.totalPages || 1);
      }
    } catch (error) {
      console.error(error);

      toast.error("Failed to fetch referred patients");
    }
  };

  // =========================================================
  // FETCH ESCALATIONS
  // =========================================================

  const fetchPendingEscalations = async (pageNumber = 1) => {
    try {
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;

      const response = await axios.get(
        `/api/renderingdoctor/pending-escalations/${userid}`,
        {
          params: {
            page: Math.max(0, pageNumber - 1),
          },

          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        const data = response.data;

        setPendingEscalations(data.content || data || []);

        setEscalationPage(data.number + 1 || pageNumber);

        setEscalationTotalPages(data.totalPages || 1);
      }
    } catch (error) {
      console.error(error);

      toast.error("Failed to fetch escalations");
    }
  };

  // =========================================================
  // FETCH FOLLOWUPS
  // =========================================================

  const fetchTodayFollowups = async (pageNumber = 1) => {
    try {
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;

      const response = await axios.get(
        `/api/renderingdoctor/today-followups/${userid}`,
        {
          params: {
            page: Math.max(0, pageNumber - 1),
          },

          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        const data = response.data;

        setFollowups(data.content || data || []);

        setFollowupPage(data.number + 1 || pageNumber);

        setFollowupTotalPages(data.totalPages || 1);
      }
    } catch (error) {
      console.error(error);

      toast.error("Failed to fetch followups");
    }
  };

  // =========================================================
  // FETCH HIGH RISK
  // =========================================================

  const fetchHighRiskPatients = async (pageNumber = 1) => {
    try {
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;

      const response = await axios.get(
        `/api/renderingdoctor/high-risk-patients/${userid}`,
        {
          params: {
            page: Math.max(0, pageNumber - 1),
          },

          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        const data = response.data;

        setHighRiskPatients(data.content || data || []);

        setHighRiskPage(data.number + 1 || pageNumber);

        setHighRiskTotalPages(data.totalPages || 1);
      }
    } catch (error) {
      console.error(error);

      toast.error("Failed to fetch high risk patients");
    }
  };

  // =========================================================
  // USE EFFECTS
  // =========================================================

  useEffect(() => {
    fetchReferredPatients(referredPage);
  }, [referredPage]);

  useEffect(() => {
    fetchPendingEscalations(escalationPage);
  }, [escalationPage]);

  useEffect(() => {
    fetchTodayFollowups(followupPage);
  }, [followupPage]);

  useEffect(() => {
    fetchHighRiskPatients(highRiskPage);
  }, [highRiskPage]);

  useEffect(() => {
    setLoading(false);
  }, []);

  // =========================================================
  // TAB CHANGE
  // =========================================================

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  // =========================================================
  // PAGINATION
  // =========================================================

  const paginationStyle = {
    "& .MuiPaginationItem-root": {
      borderRadius: "6px",
      color: "#1A237E",
      border: "1px solid #1A237E",
      fontWeight: "600",
    },

    "& .MuiPaginationItem-root.Mui-selected": {
      backgroundColor: "#1A237E",
      color: "#fff",
    },

    "& .MuiPaginationItem-root:hover": {
      backgroundColor: "#1A237E",
      color: "#fff",
    },
  };

  // =========================================================
  // TABLE STYLES
  // =========================================================

  const headerStyle = {
    backgroundColor: "#1A237E",
    color: "#fff",
    fontWeight: "bold",
    border: "1px solid #dcdcdc",
    textAlign: "center",
    whiteSpace: "nowrap",
    fontSize: "14px",
    padding: "14px",
  };

  const cellStyle = {
    border: "1px solid #dcdcdc",
    textAlign: "center",
    padding: "12px",
    whiteSpace: "nowrap",
    fontSize: "14px",
  };

  // =========================================================
  // RISK COLOR
  // =========================================================

  const getRiskColor = (risk) => {
    switch (risk?.toUpperCase()) {
      case "HIGH":
      case "CRITICAL":
        return "error";

      case "MEDIUM":
        return "warning";

      case "LOW":
        return "success";

      default:
        return "default";
    }
  };

  // =========================================================
  // LOADING
  // =========================================================

  if (loading) {
    return (
      <DashboardLayout>
        <DashboardNavbar />

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "80vh",
          }}
        >
          <CircularProgress />
        </Box>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MedicalAbstractBackground />
   
     

         

          {/* ⏱ ON-CALL SHIFT */}
          <Grid item xs={12} md={4}>
            <Card
    sx={{
      borderRadius: 4,
      boxShadow: 6,
      height: "100%",
      minHeight: 220,
      display: "flex",
      flexDirection: "column",
    }}
  >
              <CardContent>

                {/* Header */}
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Box display="flex" alignItems="center" gap={1}>
                    <AccessTimeIcon />
                    <Typography variant="h6" fontWeight="bold">
                      On-Call Shift
                    </Typography>
                  </Box>

                  <FormControlLabel
                    control={
                      <Switch
                        checked={availability}
                        onChange={handleToggleClick}
                        color="success"
                      />
                    }
                    label={
                      <Typography fontSize="12px">
                        {availability ? "On Duty" : "Off Duty"}
                      </Typography>
                    }
                  />
                </Box>

                {/* Date */}
                <Typography variant="caption" sx={{ opacity: 0.8, mt: 1 }}>
                  {new Date().toLocaleString("en-IN", {
                    weekday: "short",
                    day: "numeric",
                    month: "short",
                    year: "numeric",
                  })}
                </Typography>

                {/* Timer */}
                <Typography variant="h3" fontWeight="bold" mt={2}>
                  {timer}
                </Typography>

                {/* Status */}
                <Chip
                  label={availability ? "ACTIVE" : "OFFLINE"}
                  color={availability ? "success" : "default"}
                  size="small"
                  sx={{ mt: 2 }}
                />
              </CardContent>
            </Card>
          </Grid>


      <Box sx={{ p: 3 }}>
        {/* ========================================================= */}
        {/* TOP CARDS */}
        {/* ========================================================= */}

        <Grid container spacing={3} mb={3}>
          <Grid item xs={12} md={3}>
            <Card
              sx={{
                borderRadius: "16px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
              }}
            >
              <CardContent>
                <Box display="flex" alignItems="center" gap={2}>
                  <PeopleIcon
                    sx={{
                      fontSize: "40px",
                      color: "#1A237E",
                    }}
                  />

                  <Box>
                    <MDTypography fontWeight="bold">
                      Referred Patients
                    </MDTypography>

                    <MDTypography variant="h4" fontWeight="bold">
                      {referredPatients.length}
                    </MDTypography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={3}>
            <Card
              sx={{
                borderRadius: "16px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
              }}
            >
              <CardContent>
                <Box display="flex" alignItems="center" gap={2}>
                  <AssignmentTurnedInIcon
                    sx={{
                      fontSize: "40px",
                      color: "#d32f2f",
                    }}
                  />

                  <Box>
                    <MDTypography fontWeight="bold">
                      Escalations
                    </MDTypography>

                    <MDTypography variant="h4" fontWeight="bold">
                      {pendingEscalations.length}
                    </MDTypography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={3}>
            <Card
              sx={{
                borderRadius: "16px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
              }}
            >
              <CardContent>
                <Box display="flex" alignItems="center" gap={2}>
                  <EventAvailableIcon
                    sx={{
                      fontSize: "40px",
                      color: "#2e7d32",
                    }}
                  />

                  <Box>
                    <MDTypography fontWeight="bold">
                      Followups
                    </MDTypography>

                    <MDTypography variant="h4" fontWeight="bold">
                      {followups.length}
                    </MDTypography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={3}>
            <Card
              sx={{
                borderRadius: "16px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
              }}
            >
              <CardContent>
                <Box display="flex" alignItems="center" gap={2}>
                  <WarningIcon
                    sx={{
                      fontSize: "40px",
                      color: "#ed6c02",
                    }}
                  />

                  <Box>
                    <MDTypography fontWeight="bold">
                      High Risk
                    </MDTypography>

                    <MDTypography variant="h4" fontWeight="bold">
                      {highRiskPatients.length}
                    </MDTypography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* ========================================================= */}
        {/* TABS */}
        {/* ========================================================= */}

        <Card
          sx={{
            borderRadius: "18px",
            overflow: "hidden",
            boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
          }}
        >
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            variant="fullWidth"
            sx={{
              backgroundColor: "#ffffff",

              "& .MuiTabs-indicator": {
                backgroundColor: "#1A237E",
                height: "4px",
              },

              "& .MuiTab-root": {
                minHeight: "80px",
                fontWeight: "bold",
                fontSize: "15px",
                textTransform: "none",
                color: "#555",
                borderRight: "1px solid #e0e0e0",
              },

              "& .Mui-selected": {
                color: "#1A237E !important",
                backgroundColor: "#f4f7ff",
              },
            }}
          >
            <Tab
              icon={<PeopleIcon />}
              iconPosition="start"
              label="My Referred Patients"
            />

            <Tab
              icon={<AssignmentTurnedInIcon />}
              iconPosition="start"
              label="Pending Escalations"
            />

            <Tab
              icon={<EventAvailableIcon />}
              iconPosition="start"
              label="Today's Followups"
            />

            <Tab
              icon={<WarningIcon />}
              iconPosition="start"
              label="High Risk Patients"
            />
          </Tabs>

          <CardContent>
            {/* ========================================================= */}
            {/* REFERRED PATIENTS TABLE */}
            {/* ========================================================= */}

            {selectedTab === 0 && (
              <>
                <TableContainer
                  component={Paper}
                  sx={{
                    borderRadius: "12px",
                    overflow: "hidden",
                    border: "1px solid #ddd",
                  }}
                >
                  <Table
                    sx={{
                      tableLayout: "fixed",
                      width: "100%",
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ ...headerStyle, width: "30%" }}>
                          Patient Name
                        </TableCell>

                        <TableCell sx={{ ...headerStyle, width: "25%" }}>
                          Phone Number
                        </TableCell>

                        <TableCell sx={{ ...headerStyle, width: "25%" }}>
                          Gender
                        </TableCell>

                        <TableCell sx={{ ...headerStyle, width: "15%" }}>
                          Age
                        </TableCell>

                        <TableCell sx={{ ...headerStyle, width: "35%" }}>
                          Risk Level
                        </TableCell>
                      </TableRow>
                   

                    <TableBody>
                      {referredPatients.length > 0 ? (
                        referredPatients.map((patient, index) => (
                          <TableRow
                            key={index}
                            sx={{
                              "&:nth-of-type(even)": {
                                backgroundColor: "#fafafa",
                              },

                              "&:hover": {
                                backgroundColor: "#eef2ff",
                              },
                            }}
                          >
                            <TableCell sx={cellStyle}>
                              {patient.patientName}
                            </TableCell>

                            <TableCell sx={cellStyle}>
                              {patient.phoneNumber}
                            </TableCell>

                            <TableCell sx={cellStyle}>
                              {patient.gender}
                            </TableCell>

                            <TableCell sx={cellStyle}>
                              {patient.age}
                            </TableCell>

                            <TableCell sx={cellStyle}>
                              <Chip
                                label={patient.riskLevel}
                                color={getRiskColor(patient.riskLevel)}
                                size="small"
                              />
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell
                            colSpan={5}
                            align="center"
                            sx={cellStyle}
                          >
                            No Data Found
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                     </TableHead>
                  </Table>
                </TableContainer>

                <Box mt={3} display="flex" justifyContent="center">
                  <Pagination
                    count={referredTotalPages}
                    page={referredPage}
                    onChange={(e, value) => setReferredPage(value)}
                    sx={paginationStyle}
                  />
                </Box>
              </>
            )}

            {/* ========================================================= */}
            {/* ESCALATIONS TABLE */}
            {/* ========================================================= */}

            {selectedTab === 1 && (
              <>
                <TableContainer
                  component={Paper}
                  sx={{
                    borderRadius: "12px",
                    overflow: "hidden",
                    border: "1px solid #ddd",
                  }}
                >
                  <Table
                    sx={{
                      tableLayout: "fixed",
                      width: "100%",
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ ...headerStyle, width: "25%" }}>
                          Patient Name
                        </TableCell>

                        <TableCell sx={{ ...headerStyle, width: "20%" }}>
                          Severity
                        </TableCell>

                        <TableCell sx={{ ...headerStyle, width: "20%" }}>
                          Status
                        </TableCell>

                        <TableCell sx={{ ...headerStyle, width: "30%" }}>
                          Message
                        </TableCell>

                        <TableCell sx={{ ...headerStyle, width: "25%" }}>
                          Timestamp
                        </TableCell>
                      </TableRow>
                   

                    <TableBody>
                      {pendingEscalations.length > 0 ? (
                        pendingEscalations.map((item, index) => (
                          <TableRow key={index}>
                            <TableCell sx={cellStyle}>
                              {item.patientName}
                            </TableCell>

                            <TableCell sx={cellStyle}>
                              <Chip
                                label={item.severity}
                                color={getRiskColor(item.severity)}
                                size="small"
                              />
                            </TableCell>

                            <TableCell sx={cellStyle}>
                              {item.status}
                            </TableCell>

                            <TableCell sx={cellStyle}>
                              {item.message}
                            </TableCell>

                            <TableCell sx={cellStyle}>
                              {item.timestamp}
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell
                            colSpan={5}
                            align="center"
                            sx={cellStyle}
                          >
                            No Data Found
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                     </TableHead>
                  </Table>
                </TableContainer>

                <Box mt={3} display="flex" justifyContent="center">
                  <Pagination
                    count={escalationTotalPages}
                    page={escalationPage}
                    onChange={(e, value) => setEscalationPage(value)}
                    sx={paginationStyle}
                  />
                </Box>
              </>
            )}

            {/* ========================================================= */}
            {/* FOLLOWUPS TABLE */}
            {/* ========================================================= */}

            {selectedTab === 2 && (
              <>
                <TableContainer
                  component={Paper}
                  sx={{
                    borderRadius: "12px",
                    overflow: "hidden",
                    border: "1px solid #ddd",
                  }}
                >
                  <Table
                    sx={{
                      tableLayout: "fixed",
                      width: "100%",
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ ...headerStyle, width: "25%" }}>
                          Patient Name
                        </TableCell>

                        <TableCell sx={{ ...headerStyle, width: "20%" }}>
                          Severity
                        </TableCell>

                        <TableCell sx={{ ...headerStyle, width: "20%" }}>
                          Status
                        </TableCell>

                        <TableCell sx={{ ...headerStyle, width: "30%" }}>
                          Message
                        </TableCell>

                        <TableCell sx={{ ...headerStyle, width: "25%" }}>
                          Timestamp
                        </TableCell>
                      </TableRow>
                  

                    <TableBody>
                      {followups.length > 0 ? (
                        followups.map((item, index) => (
                          <TableRow key={index}>
                            <TableCell sx={cellStyle}>
                              {item.patientName}
                            </TableCell>

                            <TableCell sx={cellStyle}>
                              <Chip
                                label={item.severity}
                                color={getRiskColor(item.severity)}
                                size="small"
                              />
                            </TableCell>

                            <TableCell sx={cellStyle}>
                              {item.status}
                            </TableCell>

                            <TableCell sx={cellStyle}>
                              {item.message}
                            </TableCell>

                            <TableCell sx={cellStyle}>
                              {item.timestamp}
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell
                            colSpan={5}
                            align="center"
                            sx={cellStyle}
                          >
                            No Data Found
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                      </TableHead>
                  </Table>
                </TableContainer>

                <Box mt={3} display="flex" justifyContent="center">
                  <Pagination
                    count={followupTotalPages}
                    page={followupPage}
                    onChange={(e, value) => setFollowupPage(value)}
                    sx={paginationStyle}
                  />
                </Box>
              </>
            )}

            {/* ========================================================= */}
            {/* HIGH RISK TABLE */}
            {/* ========================================================= */}

            {selectedTab === 3 && (
              <>
                <TableContainer
                  component={Paper}
                  sx={{
                    borderRadius: "12px",
                    overflow: "hidden",
                    border: "1px solid #ddd",
                  }}
                >
                  <Table
                    sx={{
                      tableLayout: "fixed",
                      width: "100%",
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ ...headerStyle, width: "20%" }}>
                          Patient Name
                        </TableCell>

                        <TableCell sx={{ ...headerStyle, width: "15%" }}>
                          Gender
                        </TableCell>

                        <TableCell sx={{ ...headerStyle, width: "20%" }}>
                          Risk Level
                        </TableCell>

                        <TableCell sx={{ ...headerStyle, width: "15%" }}>
                          BP Systolic
                        </TableCell>

                        <TableCell sx={{ ...headerStyle, width: "15%" }}>
                          BP Diastolic
                        </TableCell>

                        <TableCell sx={{ ...headerStyle, width: "15%" }}>
                          BP Mean
                        </TableCell>

                        <TableCell sx={{ ...headerStyle, width: "15%" }}>
                          Random Sugar
                        </TableCell>
                      </TableRow>
                   

                    <TableBody>
                      {highRiskPatients.length > 0 ? (
                        highRiskPatients.map((patient, index) => (
                          <TableRow
                            key={index}
                            sx={{
                              "&:nth-of-type(even)": {
                                backgroundColor: "#fafafa",
                              },

                              "&:hover": {
                                backgroundColor: "#eef2ff",
                              },
                            }}
                          >
                            <TableCell sx={cellStyle}>
                              {patient.patientName || "-"}
                            </TableCell>

                            <TableCell sx={cellStyle}>
                              {patient.gender || "-"}
                            </TableCell>

                            <TableCell sx={cellStyle}>
                              <Chip
                                label={patient.riskLevel || "HIGH"}
                                color="error"
                                size="small"
                              />
                            </TableCell>

                            <TableCell sx={cellStyle}>
                              {patient?.recentHighData?.bpSystolic || "-"}
                            </TableCell>

                            <TableCell sx={cellStyle}>
                              {patient?.recentHighData?.bpDiastolic || "-"}
                            </TableCell>

                            <TableCell sx={cellStyle}>
                              {patient?.recentHighData?.bpMean || "-"}
                            </TableCell>

                            <TableCell sx={cellStyle}>
                              {patient?.recentHighData?.randomSugar || "-"}
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell
                            colSpan={7}
                            align="center"
                            sx={cellStyle}
                          >
                            No Data Found
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                     </TableHead>
                  </Table>
                </TableContainer>

                <Box mt={3} display="flex" justifyContent="center">
                  <Pagination
                    count={highRiskTotalPages}
                    page={highRiskPage}
                    onChange={(e, value) => setHighRiskPage(value)}
                    sx={paginationStyle}
                  />
                </Box>
              </>
            )}
          </CardContent>
        </Card>
      </Box>
      <Dialog
  open={confirmOpen}
  onClose={() => setConfirmOpen(false)}
  PaperProps={{
    sx: {
      borderRadius: 4,
      width: 380,
      p: 1,
    },
  }}
>
  {/* TITLE */}
  <DialogTitle
    sx={{
      textAlign: "center",
      fontWeight: 700,
      fontSize: "18px",
      color: "#1A237E",
      pb: 1,
    }}
  >
    {pendingToggle ? "Start Duty Shift" : "End Duty Shift"}
  </DialogTitle>

  {/* CONTENT */}
  <DialogContent sx={{ textAlign: "center", py: 2 }}>
    <Typography
      sx={{
        fontSize: "14px",
        color: "#555",
        lineHeight: 1.8,
      }}
    >
      {pendingToggle ? (
        <>
          You are about to begin your on-call duty shift.
          <br />
          Your shift timer will start immediately after confirmation.
          <br />
          Please confirm to continue.
        </>
      ) : (
        <>
          You are about to end your current duty shift.
          <br />
          Once confirmed, your active shift session will be closed.
          <br />
          Starting duty again will initiate a new shift session.
        </>
      )}
    </Typography>
  </DialogContent>

  {/* BUTTONS */}
  <DialogActions
    sx={{
      display: "flex",
      justifyContent: "center",
      gap: 2,
      pb: 2,
    }}
  >
    {/* CANCEL */}
    <Button
      onClick={() => setConfirmOpen(false)}
       variant="contained"
      sx={{
        backgroundColor: "#1A237E",
         color: "#fff",
        textTransform: "none",
        borderRadius: 3,
        px: 3,
        "&:hover": {
          backgroundColor: "#0D1B5E",
           color: "#fff",
        },
      }}
    >
      Cancel
    </Button>

    {/* CONFIRM */}
    <Button
      onClick={handleConfirm}
      variant="contained"
      sx={{
        backgroundColor: "#1A237E",
         color: "#fff",
        textTransform: "none",
        borderRadius: 3,
        px: 3,
        "&:hover": {
          backgroundColor: "#0D1B5E",
           color: "#fff",
        },
      }}
    >
      Confirm
    </Button>
  </DialogActions>
</Dialog>
    </DashboardLayout>
  );
}

export default RenderingDoctorDashboard;